import { render, staticRenderFns } from "./PreapprovalDetails.vue?vue&type=template&id=746b6ae5&scoped=true&"
import script from "./PreapprovalDetails.vue?vue&type=script&lang=js&"
export * from "./PreapprovalDetails.vue?vue&type=script&lang=js&"
import style0 from "./PreapprovalDetails.vue?vue&type=style&index=0&id=746b6ae5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "746b6ae5",
  null
  
)

export default component.exports